module.exports = __webpack_public_path__ + "static/media/alerts-icon-view.067cf14d.svg";